module.exports = __webpack_public_path__ + "assets/img/kf_img.81b78804.png";